var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { SourceType } from "../../../../../models/queries/queries.models";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import * as Enumerable from "linq";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { Router } from "aurelia-router";
import { RouterConstants } from "../../../../../configuration/router.constants";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { BrandClientService } from "../../../../../services/modules/brand-client.service";
var LotterySyndicates = /** @class */ (function (_super) {
    __extends(LotterySyndicates, _super);
    function LotterySyndicates(notificationService, i18N, queriesService, dialogClient, router, brandClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.queriesService = queriesService;
        _this.dialogClient = dialogClient;
        _this.router = router;
        _this.brandClientService = brandClientService;
        _this.removeLastVisitedTabCache = true;
        return _this;
    }
    LotterySyndicates.prototype.isItemABrand = function () {
        return this.item.navigationInfo && this.item.navigationInfo.brandId;
    };
    LotterySyndicates.prototype.onActivated = function (item) {
        this.brandLotteryId = item.brandLotteries[0].brandLotteryId;
        this.reLoad(item);
    };
    LotterySyndicates.prototype.reLoad = function (item) {
        var _this = this;
        this.queriesService.getEntityModels().then(function (models) {
            var e_1, _a;
            var columns = [];
            var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri.toLowerCase() == "syndicates"; });
            try {
                for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item_1 = _c.value;
                    var column = QueriesEditor.generateDefaultColumn(item_1, selectedModel);
                    columns.push(column);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var oDataUrl = "/odata/Syndicates?$filter=brandLotteryId eq ".concat(_this.brandLotteryId);
            _this.queriesService.getData(oDataUrl).then(function (response) {
                _this.itemSource = {
                    source: response.value,
                    sourceType: SourceType.Collection,
                    columns: columns,
                    groupInitialFilters: true
                };
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }).catch(function (error) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    LotterySyndicates.prototype.itemMoved = function (args) {
        var e_2, _a;
        if (args && args.detail) {
            var brandLottery = this.item.brandLotteries[0];
            var syndicates = Enumerable.from(brandLottery.syndicates).toArray();
            var syndicateId = args.detail.item.syndicateId;
            var sequenceNumber = Number(args.detail.toIndex) + 1;
            var count = 1;
            var oldSequenceNumber = Enumerable.from(syndicates).where(function (x) { return x.syndicateId == syndicateId; }).select(function (x) { return x.sequenceNumber; }).firstOrDefault();
            var difference = oldSequenceNumber - sequenceNumber;
            var current = Enumerable.from(syndicates).firstOrDefault(function (x) { return x.syndicateId == syndicateId; });
            current.sequenceNumber = sequenceNumber + (difference >= 1 ? -0.5 : 0.5);
            var orderedSyndicates = Enumerable.from(syndicates).orderBy(function (x) { return x.sequenceNumber; }).toArray();
            try {
                for (var orderedSyndicates_1 = __values(orderedSyndicates), orderedSyndicates_1_1 = orderedSyndicates_1.next(); !orderedSyndicates_1_1.done; orderedSyndicates_1_1 = orderedSyndicates_1.next()) {
                    var syndicate = orderedSyndicates_1_1.value;
                    syndicate.sequenceNumber = count;
                    var dgItem = Enumerable.from(this.dataGrid.itemsCollection).firstOrDefault(function (x) { return x.item.syndicateId == syndicate.syndicateId; });
                    if (dgItem)
                        dgItem.item.sequenceNumber = count;
                    var uowSyndicate = Enumerable.from(brandLottery.syndicates).firstOrDefault(function (x) { return x.syndicateId == syndicate.syndicateId; });
                    if (uowSyndicate)
                        uowSyndicate.sequenceNumber = count;
                    count = count + 1;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (orderedSyndicates_1_1 && !orderedSyndicates_1_1.done && (_a = orderedSyndicates_1.return)) _a.call(orderedSyndicates_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            this.dataGrid.itemsCollection = Enumerable.from(this.dataGrid.itemsCollection).orderBy(function (x) { return x.item.sequenceNumber; }).toArray();
        }
    };
    LotterySyndicates.prototype.addSyndicate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lottery, brand, brandOrOperatorByGames;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lottery = this.item;
                        brand = lottery.navigationInfo;
                        brandOrOperatorByGames = {
                            brandId: "brandId" in lottery.navigationInfo ? lottery.navigationInfo.brandId : null,
                            operatorId: 'operatorId' in lottery.navigationInfo ? lottery.navigationInfo.operatorId : null,
                            byLottery: false,
                            byInstantGames: false,
                            byBundles: false,
                            bySyndicates: true,
                            bySweepstakes: false
                        };
                        // check saved margin values in database to subscribe the instant games 
                        return [4 /*yield*/, this.brandClientService.AreMarginValuesValid(brandOrOperatorByGames).then(function (canSubscribe) {
                                if (canSubscribe) {
                                    _this.notificationService.show("Validation Error!", "Cannot be able to subscribe to syndicates since margins are not yet set. Please set the margin values and save it.", NotificationType.Error);
                                    return;
                                }
                                else {
                                    _this.removeLastVisitedTabCache = false;
                                    _this.navigateToSyndicate({
                                        brandLanguages: brand.brandLanguages ? brand.brandLanguages : [],
                                        id: 0, brandId: brand.brandId, brandName: brand.brandName,
                                        brandTemplateInternalName: lottery.brandTemplateInternalName,
                                        brandThemeInternalName: lottery.brandThemeInternalName,
                                        brandDefaultCurrencyId: brand.brandDefaultCurrencyId,
                                        brandLotteryId: _this.brandLotteryId,
                                        operatorId: brand.operatorId,
                                        lotteryPriceTiers: lottery.lotteryPriceTiers,
                                        drawnNumbers: lottery.drawnNumbers,
                                        drawnBonusNumbers: lottery.drawnBonusNumbers,
                                        drawMaximumNumber: lottery.drawMaximumNumber,
                                        drawMinimumNumber: lottery.drawMinimumNumber,
                                        drawnBonusMaximumNumber: lottery.drawnBonusMaximumNumber,
                                        drawnBonusMinimumNumber: lottery.drawnBonusMinimumNumber
                                    });
                                }
                            })];
                    case 1:
                        // check saved margin values in database to subscribe the instant games 
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LotterySyndicates.prototype.reloadDataGrid = function () {
        this.dataGrid.reloadData();
    };
    LotterySyndicates.prototype.onItemSelected = function (x) {
        var lottery = this.item;
        var brand = lottery.navigationInfo;
        var item = x.detail.item;
        this.removeLastVisitedTabCache = false;
        this.navigateToSyndicate({
            brandLanguages: brand.brandLanguages ? brand.brandLanguages : [],
            id: item.syndicateId, brandId: brand.brandId, brandName: brand.brandName,
            brandTemplateInternalName: lottery.brandTemplateInternalName,
            brandThemeInternalName: lottery.brandThemeInternalName,
            brandDefaultCurrencyId: brand.brandDefaultCurrencyId,
            brandLotteryId: this.brandLotteryId,
            operatorId: brand.operatorId,
            lotteryPriceTiers: lottery.lotteryPriceTiers,
            drawnNumbers: lottery.drawnNumbers,
            drawnBonusNumbers: lottery.drawnBonusNumbers,
            drawMaximumNumber: lottery.drawMaximumNumber,
            drawMinimumNumber: lottery.drawMinimumNumber,
            drawnBonusMaximumNumber: lottery.drawnBonusMaximumNumber,
            drawnBonusMinimumNumber: lottery.drawnBonusMinimumNumber
        });
    };
    LotterySyndicates.prototype.navigateToSyndicate = function (options) {
        var route = Enumerable.from(this.router.routes).firstOrDefault(function (x) { return x.name == RouterConstants.RouteNames.ManageSyndicate; });
        if (!route.settings)
            route.settings = {};
        route.settings.options = options;
        this.router.navigateToRoute(RouterConstants.RouteNames.ManageSyndicate, { id: options.id });
    };
    LotterySyndicates = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            QueriesClientService,
            DialogClientService,
            Router,
            BrandClientService])
    ], LotterySyndicates);
    return LotterySyndicates;
}(ChildComponent));
export { LotterySyndicates };
